export default __webpack_public_path__ + "static/media/01-bgv2.75d24868.png";